/* eslint-disable no-console */
import _ from 'underscore';
import { getItemsFromAccount } from '../consumer-account/storage-actions';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const sceneSelectionTemplate =
  `<div class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3">
    <div class="saved-asset-card">
      <div class="form-group">
        <div class="form-label">
          <img class="saved-asset-image" src="{{ thumbnailUrl }}" alt="" />
          <input type="checkbox" id="scene-{{ id }}" name="scene-{{ id }}" value="{{ id }}" data-drip="viz_key" />
          <label for="scene-{{ id }}" class="checkbox-label body-sm mt-1">{{ sceneLabel }}</label>
        </div>
      </div>
    </div>
  </div>`;

const sceneSelectionTemplateVals = _.template(sceneSelectionTemplate);

const appendSavedVisualizationScenes = (data, form) => {
  const selector = form.querySelector('.saved-visualization-scenes-row');
  data.forEach((item) => {
    item.thumbnailUrl = item['thumbnail-url'];
    // Set photo count
    let photos = item.favourites.length;
    if (photos === 1) {
      photos = `${photos} Photo`;
    } else {
      photos = `${photos} Photos`;
    }
    // Set label w/ photo count and formatted date
    const date = new Date(item['last-updated']);
    item.sceneLabel = `${photos} &bull; Updated ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    const compiled = sceneSelectionTemplateVals(item);
    const div = document.createElement('div');
    div.innerHTML = compiled;
    selector.appendChild(div.firstChild);
  });
};

const addVisualizationSceneFormGroup = (form) => {
  const { isAuthenticated } = window;
  if (!isAuthenticated) {
    return;
  }
  getItemsFromAccount('visualization', (data) => {
    if (data.visualizations.length === 0) {
      return;
    }
    appendSavedVisualizationScenes(data.visualizations, form);
  });
};

export {
  addVisualizationSceneFormGroup,
  appendSavedVisualizationScenes,
};
/* eslint-enable no-console */
